export default "__VITE_ASSET__167e0ece__"